import { render } from "./InfoSection.vue?vue&type=template&id=53bdacba"
import script from "./InfoSection.vue?vue&type=script&lang=js"
export * from "./InfoSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__